/* eslint-disable react/display-name */
import React, { useState } from "react";
import TableBase from "../../../../components/table/TableBase";
import moment from "moment";
import { DATETIME_FORMAT_FRONTEND, DAY_DATE_FORMAT } from "configs/constants";
import PoolStatus from "components/items/PoolStatus";
import { convertEmergencyStatus } from "helper/util";
import "modules/admin/orders/styles/routes.scss";
import FacturaCell from "../../../../components/FacturaCell/FacturaCell";

// for button for Print Packing Slip
import { Button } from "antd";
import generatePdfPackingSlipPool from "helper/generatePdfPackingSlipPool";
import { PrintPDFIcon } from "components/svgs";

const FlexioPoolTable = ({
  dataSource,
  pagination,
  hiddenColumns = [],
  setSelectedPackage,
  setShowUpdateStatus,
  selectedRowKeys = [],
  onSelectionChange,
  showCheckboxes = false,
  ...props
}) => {
  // Handles the "loading" state for Printing (grey out until done)
  const [printing, setPrinting] = useState(false);

  // This function gets details and creates the PDF packing slip(s).
  // Data "dataSource" is coming from "PackageList" in FlexioPoolList.jsx; e.g. array of 20 packages.
  const handlePrintPackingSlipPool = async (packageId) => {
    // The logic that was here in the Shift version, was just preparatory for passing to generatePdfPackingSlip. No need to pre-manage the Flexio Pool Packages.

    try {
      // grey out screen for loading
      setPrinting(true);

      // calls helper/generatePdfPackingSlipPool with both datasouce (array of 20 / filtered) and distinct package ID for printing single
      const doc = await generatePdfPackingSlipPool(dataSource, packageId);
      const filename = `Flexio-Pool-` + packageId?.substr(0, 8)?.toUpperCase() + `.pdf`;
      doc?.save(filename);
    } finally {
      // un-grey out screen for loading
      setPrinting(false);
    }
  };

  const columns = [
    {
      title: "Print",
      width: 60,
      fixed: "left",
      render: (record) => {
        const { id } = record;
        return (
          <Button
            size="small"
            type="link"
            onClick={() => handlePrintPackingSlipPool(id)}
            loading={printing}
            title="Print Packing Slip"
          >
            <PrintPDFIcon />
          </Button>
        );
      }
    },
    {
      title: "Package ID",
      dataIndex: "id",
      fixed: "left",
      width: 70,
      render: (value) => {
        return (
          <p style={{ margin: 0, color: "#1f3998" }}>
            {value.substr(0, 8).toUpperCase()}
          </p>
        );
      }
    },
    {
      title: "Order ID",
      width: 70,
      dataIndex: "orderV2_id",
      render: (value) => {
        return (
          <p style={{ margin: 0, color: "#1f3998" }}>
            {value.substr(0, 8).toUpperCase()}
          </p>
        );
      }
    },
    {
      title: "Status",
      width: 70,
      render: (record) => (
        <PoolStatus
          value={convertEmergencyStatus(record)}
          isAdmin={false}
          record={record}
          setSelectedPackage={setSelectedPackage}
          setShowUpdateStatus={setShowUpdateStatus}
        />
      )
    },
    {
      title: "Factura",
      width: 120,
      render: (record) => <FacturaCell factura={record.factura} isAdmin={false} />
    },
    {
      title: "Pickup Stop Name",
      width: 70,
      dataIndex: "pickupStopName",
      render: (value) => {
        return <p>{value}</p>;
      }
    },
    {
      title: "Pickup Address",
      width: 130,
      render: (record) => {
        return (
          record?.pickupPhysicalAddress ||
          record?.pickupDisplayAddress ||
          record?.pickupAddress ||
          "N/A"
        );
      }
    },
    {
      title: "Dropoff Stop Name",
      width: 70,
      dataIndex: "dropoffStopName",
      render: (value) => {
        return <p>{value}</p>;
      }
    },
    {
      title: "Dropoff Address",
      width: 130,
      render: (record) => {
        return (
          record?.dropoffPhysicalAddress ||
          record?.dropoffDisplayAddress ||
          record?.dropoffAddress ||
          "N/A"
        );
      }
    },
    {
      title: "Pickup Date",
      width: 110,
      dataIndex: "pickupDate",
      render: (value) => moment(value).format(DAY_DATE_FORMAT)
    },
    {
      title: "Created At",
      width: 110,
      dataIndex: "createdAt",
      render: (value) => moment(value).format(DATETIME_FORMAT_FRONTEND)
    }
  ];
  const filteredColumns =
    hiddenColumns.length > 0
      ? columns.filter((col) => !hiddenColumns.includes(col.title))
      : columns;

  // Row selection configuration for checkboxes
  const rowSelection = showCheckboxes
    ? {
        selectedRowKeys,
        onChange: (selectedKeys) => {
          if (onSelectionChange) {
            onSelectionChange(selectedKeys);
          }
        },
        getCheckboxProps: (record) => ({
          name: record.id
        })
      }
    : null;

  return (
    <>
      <TableBase
        columns={filteredColumns}
        data={dataSource}
        pagination={pagination}
        rowKey="id"
        rowSelection={rowSelection}
        {...props}
      />
      {/* img required as a target for generatePdfPackingSlipPool jsBarcode to render against. It's CSS is set to display none. */}
      <img id="poolPackageBarcode" />
    </>
  );
};
export default FlexioPoolTable;
